import React from "react";
import { Navigate } from "react-router-dom";
import { useCustomer } from "../contexts/ResellerCustomerContext";

const CustomerProtectedRoute = ({ children, resellerUuid }) => {
    const { isAuthenticated, loading } = useCustomer();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to={`/online-store/${resellerUuid}/login`} replace />;
    }

    return children;
};

export default CustomerProtectedRoute;
